import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const enappgyRDMServiceApi = createApi({
  reducerPath: 'enappgyRDMServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_RDM_URL
  }),
  tagTypes: ['PowerLevel'],
  endpoints: (builder) => ({
    //Queries
    getPowerLevel: builder.query({
      query: ({ areaId }) => {
        return `${areaId}/GetPowerLevel`
      },
      providesTags: ['PowerLevel']
    }),
    controlAreaLights: builder.mutation({
      query: ({ areaId, powerLevel }) => ({
        url: `${areaId}/SetPowerLevel?powerLevel=${powerLevel}`,
        method: 'POST'
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useControlAreaLightsMutation,
  useGetPowerLevelQuery,
  useLazyGetPowerLevelQuery
} = enappgyRDMServiceApi;
